// src/components/Modals/XModal/emojiData.js

export const emojiCategories = {
  'Yüzler ve İfadeler': [
    { emoji: '😀', name: 'grinning', tr: 'sırıtan gülen gülümseme' },
    { emoji: '😃', name: 'smiley', tr: 'gülen mutlu neşeli' },
    { emoji: '😄', name: 'smile', tr: 'gülümseme mutlu sevinçli' },
    { emoji: '😁', name: 'grin', tr: 'sırıtma büyük gülüş' },
    { emoji: '😆', name: 'laughing', tr: 'kahkaha gülen eğlenen' },
    { emoji: '😅', name: 'sweat_smile', tr: 'terleyen gülümseme utangaç' },
    { emoji: '🤣', name: 'rofl', tr: 'kahkaha yuvarlanma çok gülen' },
    { emoji: '😂', name: 'joy', tr: 'gözyaşı mutluluk sevinç kahkaha' },
    { emoji: '🙂', name: 'slightly_smiling', tr: 'hafif gülümseme' },
    { emoji: '🙃', name: 'upside_down', tr: 'ters yüz ironik' },
    { emoji: '😉', name: 'wink', tr: 'göz kırpma flört' },
    { emoji: '😊', name: 'blush', tr: 'utanan kızaran mutlu' },
    { emoji: '😇', name: 'innocent', tr: 'melek hale masum' },
    { emoji: '🥰', name: 'love', tr: 'aşık sevgi kalp' },
    { emoji: '😍', name: 'heart_eyes', tr: 'kalp gözler aşık sevgi' },
    { emoji: '🤩', name: 'star_struck', tr: 'yıldız gözler hayranlık' },
    { emoji: '😘', name: 'kissing_heart', tr: 'öpücük kalp öpüş sevgi' },
    { emoji: '😗', name: 'kissing', tr: 'öpücük öpüş' },
    { emoji: '😚', name: 'kissing_closed_eyes', tr: 'gözler kapalı öpücük' },
    { emoji: '😙', name: 'kissing_smiling_eyes', tr: 'gülen gözler öpücük' },
    { emoji: '🥲', name: 'smiling_tear', tr: 'gözyaşı gülümseme duygulandım' },
    { emoji: '😋', name: 'yum', tr: 'lezzetli nefis yummy yemek' },
    { emoji: '😛', name: 'stuck_out_tongue', tr: 'dil çıkaran şakacı' },
    { emoji: '😜', name: 'stuck_out_tongue_winking', tr: 'dil göz kırpma' },
    { emoji: '🤪', name: 'zany', tr: 'çılgın deli' },
    { emoji: '😝', name: 'stuck_out_tongue_closed_eyes', tr: 'dil gözler kapalı' },
    { emoji: '🤑', name: 'money_mouth', tr: 'para ağzı zengin dolar' },
    { emoji: '🤗', name: 'hugging', tr: 'sarılma kucaklama' },
    { emoji: '🤭', name: 'hand_over_mouth', tr: 'ağız kapalı utangaç' },
    { emoji: '🤫', name: 'shushing', tr: 'sus sessiz' },
    { emoji: '🤔', name: 'thinking', tr: 'düşünen düşünüyor' },
    { emoji: '🤐', name: 'zipper_mouth', tr: 'fermuar ağız sessiz' },
    { emoji: '🤨', name: 'raised_eyebrow', tr: 'kaş kaldırma şüpheli' },
    { emoji: '😐', name: 'neutral', tr: 'nötr ifadesiz' },
    { emoji: '😑', name: 'expressionless', tr: 'ifadesiz boş' },
    { emoji: '😶', name: 'no_mouth', tr: 'ağızsız sessiz' },
    { emoji: '😏', name: 'smirk', tr: 'alaycı sırıtış' },
    { emoji: '😒', name: 'unamused', tr: 'keyifsiz sıkılmış' },
    { emoji: '🙄', name: 'rolling_eyes', tr: 'göz devirme' },
    { emoji: '😬', name: 'grimacing', tr: 'yüz buruşturan' },
    { emoji: '😮‍💨', name: 'exhaling', tr: 'nefes verme rahatladım' },
    { emoji: '🤥', name: 'lying', tr: 'yalan söyleyen pinokyo' },
    { emoji: '😌', name: 'relieved', tr: 'rahatlamış huzurlu' },
    { emoji: '😔', name: 'pensive', tr: 'düşünceli üzgün kederli' },
    { emoji: '😪', name: 'sleepy', tr: 'uykulu uyku' },
    { emoji: '🤤', name: 'drooling', tr: 'salya akan açlık' },
    { emoji: '😴', name: 'sleeping', tr: 'uyuyan uyku horultu' },
    { emoji: '😷', name: 'mask', tr: 'maske hastalık grip' },
    { emoji: '🤒', name: 'thermometer', tr: 'hasta ateş termometre' },
    { emoji: '🤕', name: 'head_bandage', tr: 'yaralı bandaj' },
    { emoji: '🤢', name: 'nauseated', tr: 'mide bulantı hasta' },
    { emoji: '🤮', name: 'vomiting', tr: 'kusma hasta' },
    { emoji: '🤧', name: 'sneezing', tr: 'hapşırma hasta grip' },
    { emoji: '🥵', name: 'hot', tr: 'sıcak terleyen' },
    { emoji: '🥶', name: 'cold', tr: 'soğuk donma üşüme' },
    { emoji: '🥴', name: 'woozy', tr: 'sersem sarhoş' },
    { emoji: '😵', name: 'dizzy', tr: 'sersem baş dönmesi' },
    { emoji: '😵‍💫', name: 'dizzy_spiral', tr: 'çok sersem şaşkın' },
    { emoji: '🤯', name: 'exploding_head', tr: 'patlayan kafa şok' },
    { emoji: '😕', name: 'confused', tr: 'şaşkın kafası karışık' },
    { emoji: '😟', name: 'worried', tr: 'endişeli kaygılı' },
    { emoji: '🙁', name: 'frowning', tr: 'somurtkan üzgün' },
    { emoji: '☹️', name: 'frowning2', tr: 'çok üzgün mutsuz' },
    { emoji: '😮', name: 'open_mouth', tr: 'açık ağız şaşkın' },
    { emoji: '😯', name: 'hushed', tr: 'sessiz şaşırmış' },
    { emoji: '😲', name: 'astonished', tr: 'şaşırmış hayret' },
    { emoji: '😳', name: 'flushed', tr: 'utanan mahcup kızaran' },
    { emoji: '🥺', name: 'pleading', tr: 'yalvaran üzgün göz' },
    { emoji: '😦', name: 'frowning_mouth', tr: 'üzgün açık ağız' },
    { emoji: '😧', name: 'anguished', tr: 'acı çeken sıkıntılı' },
    { emoji: '😨', name: 'fearful', tr: 'korkmuş korku' },
    { emoji: '😰', name: 'cold_sweat', tr: 'soğuk ter endişeli' },
    { emoji: '😥', name: 'disappointed_relieved', tr: 'rahatlamış üzgün' },
    { emoji: '😢', name: 'cry', tr: 'ağlayan gözyaşı üzgün' },
    { emoji: '😭', name: 'sob', tr: 'hıçkırık ağlama çok üzgün' },
    { emoji: '😱', name: 'scream', tr: 'çığlık korku panik' },
    { emoji: '😖', name: 'confounded', tr: 'sıkılmış rahatsız' },
    { emoji: '😣', name: 'persevere', tr: 'sebat ısrarlı zorluk' },
    { emoji: '😞', name: 'disappointed', tr: 'hayal kırıklığı üzgün' },
    { emoji: '😓', name: 'sweat', tr: 'endişeli terli stresli' },
    { emoji: '😩', name: 'weary', tr: 'bitkin yorgun' },
    { emoji: '😫', name: 'tired', tr: 'çok yorgun bitkin' },
    { emoji: '🥱', name: 'yawning', tr: 'esneme uykulu sıkılmış' },
    { emoji: '😤', name: 'triumph', tr: 'zafer burun delikleri öfke' },
    { emoji: '😡', name: 'rage', tr: 'öfke hiddet çok kızgın' },
    { emoji: '😠', name: 'angry', tr: 'kızgın sinirli öfkeli' },
    { emoji: '🤬', name: 'cursing', tr: 'küfür eden çok kızgın' },
    { emoji: '😈', name: 'smiling_imp', tr: 'şeytan kötü' },
    { emoji: '👿', name: 'imp', tr: 'şeytan öfkeli kötü' },
    { emoji: '💀', name: 'skull', tr: 'kafatası ölüm' },
    { emoji: '☠️', name: 'skull_crossbones', tr: 'korsanlar ölüm tehlike' },
  ],

  'Kalpler ve Sevgi': [
    { emoji: '❤️', name: 'red_heart', tr: 'kırmızı kalp aşk sevgi' },
    { emoji: '🧡', name: 'orange_heart', tr: 'turuncu kalp' },
    { emoji: '💛', name: 'yellow_heart', tr: 'sarı kalp' },
    { emoji: '💚', name: 'green_heart', tr: 'yeşil kalp' },
    { emoji: '💙', name: 'blue_heart', tr: 'mavi kalp' },
    { emoji: '💜', name: 'purple_heart', tr: 'mor kalp' },
    { emoji: '🖤', name: 'black_heart', tr: 'siyah kalp' },
    { emoji: '🤍', name: 'white_heart', tr: 'beyaz kalp' },
    { emoji: '🤎', name: 'brown_heart', tr: 'kahverengi kalp' },
    { emoji: '💔', name: 'broken_heart', tr: 'kırık kalp üzgün ayrılık' },
    { emoji: '❤️‍🔥', name: 'heart_fire', tr: 'ateşli kalp tutkulu' },
    { emoji: '❤️‍🩹', name: 'mending_heart', tr: 'iyileşen kalp' },
    { emoji: '💕', name: 'two_hearts', tr: 'iki kalp çift aşk' },
    { emoji: '💞', name: 'revolving_hearts', tr: 'dönen kalpler' },
    { emoji: '💓', name: 'heartbeat', tr: 'kalp atışı' },
    { emoji: '💗', name: 'growing_heart', tr: 'büyüyen kalp' },
    { emoji: '💖', name: 'sparkling_heart', tr: 'parlayan kalp' },
    { emoji: '💘', name: 'cupid', tr: 'aşk oku küpid' },
    { emoji: '💝', name: 'gift_heart', tr: 'hediye kalp' },
    { emoji: '💟', name: 'heart_decoration', tr: 'kalp dekorasyon' },
    { emoji: '💌', name: 'love_letter', tr: 'aşk mektubu sevgi' },
    { emoji: '💋', name: 'kiss', tr: 'öpücük dudak izi' },
    { emoji: '💏', name: 'kiss_person', tr: 'öpüşen insanlar' },
    { emoji: '💑', name: 'couple_heart', tr: 'kalpli çift aşıklar' },
  ],

  'Jestler ve Eller': [
    { emoji: '👋', name: 'wave', tr: 'el sallama merhaba hoşçakal' },
    { emoji: '🤚', name: 'raised_back_hand', tr: 'el arkası dur' },
    { emoji: '🖐️', name: 'hand_splayed', tr: 'açık el beş parmak' },
    { emoji: '✋', name: 'raised_hand', tr: 'el kaldırma dur' },
    { emoji: '🖖', name: 'vulcan', tr: 'vulcan selamı' },
    { emoji: '👌', name: 'ok_hand', tr: 'tamam ok el' },
    { emoji: '🤌', name: 'pinched_fingers', tr: 'birleşik parmaklar' },
    { emoji: '🤏', name: 'pinching_hand', tr: 'kıstırma küçük' },
    { emoji: '✌️', name: 'victory', tr: 'zafer barış v işareti' },
    { emoji: '🤞', name: 'crossed_fingers', tr: 'çapraz parmak şans' },
    { emoji: '🤟', name: 'love_you', tr: 'seni seviyorum el' },
    { emoji: '🤘', name: 'metal', tr: 'metal rock işareti' },
    { emoji: '🤙', name: 'call_me', tr: 'ara beni telefon' },
    { emoji: '👈', name: 'point_left', tr: 'sol gösterme işaret' },
    { emoji: '👉', name: 'point_right', tr: 'sağ gösterme işaret' },
    { emoji: '👆', name: 'point_up_2', tr: 'yukarı işaret' },
    { emoji: '🖕', name: 'middle_finger', tr: 'orta parmak' },
    { emoji: '👇', name: 'point_down', tr: 'aşağı işaret' },
    { emoji: '☝️', name: 'point_up', tr: 'yukarı gösterme' },
    { emoji: '👍', name: 'thumbsup', tr: 'beğeni başparmak yukarı like' },
    { emoji: '👎', name: 'thumbsdown', tr: 'beğenmeme başparmak aşağı dislike' },
    { emoji: '✊', name: 'fist', tr: 'yumruk güç' },
    { emoji: '👊', name: 'punch', tr: 'yumruk vuruş' },
    { emoji: '🤛', name: 'left_fist', tr: 'sol yumruk' },
    { emoji: '🤜', name: 'right_fist', tr: 'sağ yumruk' },
    { emoji: '👏', name: 'clap', tr: 'alkış el çırpma' },
    { emoji: '🙌', name: 'raised_hands', tr: 'eller yukarı kutlama' },
    { emoji: '👐', name: 'open_hands', tr: 'açık eller' },
    { emoji: '🤲', name: 'palms_up', tr: 'avuç yukarı dua' },
    { emoji: '🤝', name: 'handshake', tr: 'el sıkışma tokalaşma anlaşma' },
    { emoji: '🙏', name: 'pray', tr: 'dua namaste teşekkür' },
    { emoji: '✍️', name: 'writing_hand', tr: 'yazan el kalem' },
    { emoji: '💅', name: 'nail_care', tr: 'tırnak bakımı manikür' },
    { emoji: '🤳', name: 'selfie', tr: 'özçekim selfi' },
    { emoji: '💪', name: 'muscle', tr: 'kas güç kuvvet spor' },
  ],

  'Hayvanlar': [
    { emoji: '🐶', name: 'dog', tr: 'köpek hayvan evcil' },
    { emoji: '🐱', name: 'cat', tr: 'kedi hayvan evcil' },
    { emoji: '🐭', name: 'mouse', tr: 'fare hayvan' },
    { emoji: '🐹', name: 'hamster', tr: 'hamster criceto hayvan' },
    { emoji: '🐰', name: 'rabbit', tr: 'tavşan hayvan' },
    { emoji: '🦊', name: 'fox', tr: 'tilki hayvan' },
    { emoji: '🐻', name: 'bear', tr: 'ayı hayvan' },
    { emoji: '🐼', name: 'panda', tr: 'panda ayı hayvan' },
    { emoji: '🐨', name: 'koala', tr: 'koala ayı hayvan' },
    { emoji: '🐯', name: 'tiger', tr: 'kaplan hayvan' },
    { emoji: '🦁', name: 'lion', tr: 'aslan hayvan kral' },
    { emoji: '🐮', name: 'cow', tr: 'inek hayvan süt' },
    { emoji: '🐷', name: 'pig', tr: 'domuz hayvan' },
    { emoji: '🐸', name: 'frog', tr: 'kurbağa hayvan' },
    { emoji: '🐵', name: 'monkey', tr: 'maymun hayvan' },
    { emoji: '🙈', name: 'see_no_evil', tr: 'görmezden gel maymun' },
    { emoji: '🙉', name: 'hear_no_evil', tr: 'duymadım maymun' },
    { emoji: '🙊', name: 'speak_no_evil', tr: 'konuşmam maymun' },
    { emoji: '🐔', name: 'chicken', tr: 'tavuk hayvan' },
    { emoji: '🐧', name: 'penguin', tr: 'penguen kuş' },
    { emoji: '🐦', name: 'bird', tr: 'kuş hayvan' },
    { emoji: '🐤', name: 'baby_chick', tr: 'civciv bebek' },
    { emoji: '🐣', name: 'hatching_chick', tr: 'yumurtadan çıkan civciv' },
    { emoji: '🐥', name: 'hatched_chick', tr: 'civciv yumurta' },
    { emoji: '🦆', name: 'duck', tr: 'ördek hayvan' },
    { emoji: '🦅', name: 'eagle', tr: 'kartal kuş' },
    { emoji: '🦉', name: 'owl', tr: 'baykuş kuş gece' },
    { emoji: '🦇', name: 'bat', tr: 'yarasa hayvan gece' },
    { emoji: '🐺', name: 'wolf', tr: 'kurt hayvan' },
    { emoji: '🐗', name: 'boar', tr: 'yaban domuzu hayvan' },
    { emoji: '🐴', name: 'horse', tr: 'at hayvan' },
    { emoji: '🦄', name: 'unicorn', tr: 'tek boynuzlu at unicorn' },
    { emoji: '🐝', name: 'bee', tr: 'arı bal hayvan' },
    { emoji: '🐛', name: 'bug', tr: 'böcek tırtıl' },
    { emoji: '🦋', name: 'butterfly', tr: 'kelebek hayvan' },
    { emoji: '🐌', name: 'snail', tr: 'salyangoz yavaş' },
    { emoji: '🐞', name: 'beetle', tr: 'uğur böceği' },
    { emoji: '🐜', name: 'ant', tr: 'karınca hayvan' },
    { emoji: '🕷️', name: 'spider', tr: 'örümcek hayvan' },
    { emoji: '🦂', name: 'scorpion', tr: 'akrep hayvan' },
    { emoji: '🐢', name: 'turtle', tr: 'kaplumbağa yavaş hayvan' },
    { emoji: '🐍', name: 'snake', tr: 'yılan hayvan' },
    { emoji: '🦎', name: 'lizard', tr: 'kertenkele hayvan' },
    { emoji: '🐉', name: 'dragon', tr: 'ejderha' },
    { emoji: '🦕', name: 'dinosaur', tr: 'dinozor' },
    { emoji: '🐊', name: 'crocodile', tr: 'timsah hayvan' },
    { emoji: '🐋', name: 'whale', tr: 'balina hayvan deniz' },
    { emoji: '🐬', name: 'dolphin', tr: 'yunus balığı deniz' },
    { emoji: '🐟', name: 'fish', tr: 'balık hayvan deniz' },
    { emoji: '🐠', name: 'tropical_fish', tr: 'tropikal balık renkli' },
    { emoji: '🐡', name: 'blowfish', tr: 'balon balığı' },
    { emoji: '🦈', name: 'shark', tr: 'köpekbalığı tehlikeli' },
    { emoji: '🐙', name: 'octopus', tr: 'ahtapot deniz' },
    { emoji: '🦀', name: 'crab', tr: 'yengeç deniz' },
    { emoji: '🦐', name: 'shrimp', tr: 'karides deniz' },
    { emoji: '🦑', name: 'squid', tr: 'kalamar deniz' },
  ],

  'Yiyecek ve İçecek': [
    { emoji: '🍎', name: 'apple', tr: 'elma meyve kırmızı' },
    { emoji: '🍏', name: 'green_apple', tr: 'yeşil elma meyve' },
    { emoji: '🍐', name: 'pear', tr: 'armut meyve' },
    { emoji: '🍊', name: 'tangerine', tr: 'mandalina portakal turuncu' },
    { emoji: '🍋', name: 'lemon', tr: 'limon sarı ekşi' },
    { emoji: '🍌', name: 'banana', tr: 'muz meyve sarı' },
    { emoji: '🍉', name: 'watermelon', tr: 'karpuz meyve yaz' },
    { emoji: '🍇', name: 'grapes', tr: 'üzüm meyve mor' },
    { emoji: '🍓', name: 'strawberry', tr: 'çilek meyve kırmızı' },
    { emoji: '🫐', name: 'blueberries', tr: 'yaban mersini mavi' },
    { emoji: '🍈', name: 'melon', tr: 'kavun meyve' },
    { emoji: '🍒', name: 'cherries', tr: 'kiraz meyve kırmızı' },
    { emoji: '🍑', name: 'peach', tr: 'şeftali meyve' },
    { emoji: '🥭', name: 'mango', tr: 'mango tropikal meyve' },
    { emoji: '🍍', name: 'pineapple', tr: 'ananas tropikal meyve' },
    { emoji: '🥥', name: 'coconut', tr: 'hindistan cevizi' },
    { emoji: '🥝', name: 'kiwi', tr: 'kivi meyve yeşil' },
    { emoji: '🍅', name: 'tomato', tr: 'domates sebze kırmızı' },
    { emoji: '🍆', name: 'eggplant', tr: 'patlıcan sebze mor' },
    { emoji: '🥑', name: 'avocado', tr: 'avokado yeşil' },
    { emoji: '🥦', name: 'broccoli', tr: 'brokoli sebze yeşil' },
    { emoji: '🥬', name: 'leafy_green', tr: 'yapraklı sebze salata' },
    { emoji: '🥒', name: 'cucumber', tr: 'salatalık sebze yeşil' },
    { emoji: '🌶️', name: 'hot_pepper', tr: 'acı biber kırmızı' },
    { emoji: '🌽', name: 'corn', tr: 'mısır sebze sarı' },
    { emoji: '🥕', name: 'carrot', tr: 'havuç sebze turuncu' },
    { emoji: '🥔', name: 'potato', tr: 'patates sebze' },
    { emoji: '🍠', name: 'sweet_potato', tr: 'tatlı patates' },
    { emoji: '🍞', name: 'bread', tr: 'ekmek' },
    { emoji: '🥐', name: 'croissant', tr: 'kruvasan fransız' },
    { emoji: '🥖', name: 'baguette', tr: 'somun ekmek fransız' },
    { emoji: '🥨', name: 'pretzel', tr: 'gevrek alman' },
    { emoji: '🥯', name: 'bagel', tr: 'simit ekmek' },
    { emoji: '🧀', name: 'cheese', tr: 'peynir sarı' },
    { emoji: '🥚', name: 'egg', tr: 'yumurta beyaz' },
    { emoji: '🍳', name: 'cooking', tr: 'pişirme yemek sahanda' },
    { emoji: '🥓', name: 'bacon', tr: 'pastırma domuz eti' },
    { emoji: '🥞', name: 'pancakes', tr: 'krep pankek' },
    { emoji: '🧇', name: 'waffle', tr: 'waffle kahvaltı' },
    { emoji: '🍗', name: 'poultry_leg', tr: 'tavuk budu' },
    { emoji: '🍖', name: 'meat', tr: 'kemikli et' },
    { emoji: '🍕', name: 'pizza', tr: 'pizza italyan yemek' },
    { emoji: '🌭', name: 'hotdog', tr: 'sosisli sandviç amerikan' },
    { emoji: '🍔', name: 'hamburger', tr: 'hamburger amerikan' },
    { emoji: '🍟', name: 'fries', tr: 'patates kızartması' },
    { emoji: '🌮', name: 'taco', tr: 'tako meksika' },
    { emoji: '🌯', name: 'burrito', tr: 'burrito meksika' },
    { emoji: '🥙', name: 'stuffed_flatbread', tr: 'dürüm döner' },
    { emoji: '🥗', name: 'salad', tr: 'salata sebze sağlıklı' },
    { emoji: '🍝', name: 'spaghetti', tr: 'spagetti makarna italyan' },
    { emoji: '🍜', name: 'ramen', tr: 'erişte çorba japon' },
    { emoji: '🍲', name: 'stew', tr: 'güveç yemek' },
    { emoji: '🍛', name: 'curry', tr: 'köri hint yemek' },
    { emoji: '🍣', name: 'sushi', tr: 'suşi japon balık' },
    { emoji: '🍱', name: 'bento', tr: 'bento kutusu japon' },
    { emoji: '🥟', name: 'dumpling', tr: 'mantı çin' },
    { emoji: '🍤', name: 'fried_shrimp', tr: 'kızarmış karides' },
    { emoji: '🍙', name: 'rice_ball', tr: 'pirinç topu japon' },
    { emoji: '🍚', name: 'rice', tr: 'pirinç pilav' },
    { emoji: '🍘', name: 'rice_cracker', tr: 'pirinç gevreği' },
    { emoji: '🍥', name: 'fish_cake', tr: 'balık köftesi japon' },
    { emoji: '🥠', name: 'fortune_cookie', tr: 'fal kurabiyesi çin' },
    { emoji: '🥮', name: 'moon_cake', tr: 'ay keki çin' },
    { emoji: '🍢', name: 'oden', tr: 'japon yemeği şiş' },
    { emoji: '🍡', name: 'dango', tr: 'japon tatlısı' },
    { emoji: '🍧', name: 'shaved_ice', tr: 'buz tatlısı' },
    { emoji: '🍨', name: 'ice_cream', tr: 'dondurma kase' },
    { emoji: '🍦', name: 'icecream', tr: 'dondurma külah' },
    { emoji: '🥧', name: 'pie', tr: 'turta börek tatlı' },
    { emoji: '🧁', name: 'cupcake', tr: 'kek muffin' },
    { emoji: '🍰', name: 'cake', tr: 'pasta kek dilim' },
    { emoji: '🎂', name: 'birthday', tr: 'doğum günü pasta mum' },
    { emoji: '🍮', name: 'custard', tr: 'muhallebi krema' },
    { emoji: '🍭', name: 'lollipop', tr: 'lolipop şeker' },
    { emoji: '🍬', name: 'candy', tr: 'şeker tatlı' },
    { emoji: '🍫', name: 'chocolate', tr: 'çikolata kahverengi' },
    { emoji: '🍿', name: 'popcorn', tr: 'patlamış mısır sinema' },
    { emoji: '🍩', name: 'doughnut', tr: 'donut tatlı' },
    { emoji: '🍪', name: 'cookie', tr: 'kurabiye' },
    { emoji: '🌰', name: 'chestnut', tr: 'kestane' },
    { emoji: '🥜', name: 'peanuts', tr: 'fıstık yer fıstığı' },
    { emoji: '🍯', name: 'honey', tr: 'bal küpü arı' },
    { emoji: '🥛', name: 'milk', tr: 'süt beyaz bardak' },
    { emoji: '🍼', name: 'baby_bottle', tr: 'biberon bebek süt' },
    { emoji: '☕', name: 'coffee', tr: 'kahve sıcak fincan' },
    { emoji: '🫖', name: 'teapot', tr: 'çaydanlık demlik' },
    { emoji: '🍵', name: 'tea', tr: 'çay yeşil japon' },
    { emoji: '🧃', name: 'juice_box', tr: 'meyve suyu kutu' },
    { emoji: '🧋', name: 'bubble_tea', tr: 'bubble tea boba' },
    { emoji: '🥤', name: 'cup_straw', tr: 'pipetli bardak' },
    { emoji: '🍶', name: 'sake', tr: 'sake japon içki' },
    { emoji: '🍺', name: 'beer', tr: 'bira alkol' },
    { emoji: '🍻', name: 'beers', tr: 'biralar kutlama' },
    { emoji: '🥂', name: 'champagne_glass', tr: 'şampanya kadeh kutlama' },
    { emoji: '🍷', name: 'wine', tr: 'şarap kadeh kırmızı' },
    { emoji: '🥃', name: 'tumbler', tr: 'viski kadeh' },
    { emoji: '🍸', name: 'cocktail', tr: 'kokteyl içki' },
    { emoji: '🍹', name: 'tropical_drink', tr: 'tropikal içecek' },
    { emoji: '🍾', name: 'champagne', tr: 'şampanya kutlama' },
  ],

  'Aktiviteler ve Sporlar': [
    { emoji: '⚽', name: 'soccer', tr: 'futbol topu spor' },
    { emoji: '🏀', name: 'basketball', tr: 'basketbol topu spor' },
    { emoji: '🏈', name: 'football', tr: 'amerikan futbolu' },
    { emoji: '⚾', name: 'baseball', tr: 'beyzbol topu' },
    { emoji: '🥎', name: 'softball', tr: 'softball topu' },
    { emoji: '🎾', name: 'tennis', tr: 'tenis topu raket' },
    { emoji: '🏐', name: 'volleyball', tr: 'voleybol topu' },
    { emoji: '🏉', name: 'rugby', tr: 'rugby topu' },
    { emoji: '🥏', name: 'frisbee', tr: 'frizbi disk' },
    { emoji: '🎱', name: '8ball', tr: 'bilardo topu sekiz' },
    { emoji: '🪀', name: 'yoyo', tr: 'yoyo oyuncak' },
    { emoji: '🏓', name: 'ping_pong', tr: 'masa tenisi' },
    { emoji: '🏸', name: 'badminton', tr: 'badminton' },
    { emoji: '🏒', name: 'hockey', tr: 'hokey buz' },
    { emoji: '🏑', name: 'field_hockey', tr: 'çim hokeyi' },
    { emoji: '🥍', name: 'lacrosse', tr: 'lakros' },
    { emoji: '🏏', name: 'cricket', tr: 'kriket bat' },
    { emoji: '🥅', name: 'goal', tr: 'kale gol' },
    { emoji: '⛳', name: 'golf', tr: 'golf bayrak delik' },
    { emoji: '🪁', name: 'kite', tr: 'uçurtma' },
    { emoji: '🏹', name: 'bow_arrow', tr: 'okçuluk ok yay' },
    { emoji: '🎣', name: 'fishing', tr: 'balık tutma olta' },
    { emoji: '🤿', name: 'diving_mask', tr: 'dalış maskesi' },
    { emoji: '🥊', name: 'boxing_glove', tr: 'boks eldiveni' },
    { emoji: '🥋', name: 'martial_arts', tr: 'dövüş sanatları karate' },
    { emoji: '🎽', name: 'running_shirt', tr: 'koşu tişörtü maraton' },
    { emoji: '🛹', name: 'skateboard', tr: 'kaykay' },
    { emoji: '🛼', name: 'roller_skate', tr: 'paten' },
    { emoji: '🛷', name: 'sled', tr: 'kızak kar' },
    { emoji: '⛸️', name: 'ice_skate', tr: 'buz pateni' },
    { emoji: '🥌', name: 'curling_stone', tr: 'curling taşı' },
    { emoji: '🎿', name: 'ski', tr: 'kayak kar' },
    { emoji: '⛷️', name: 'skier', tr: 'kayakçı' },
    { emoji: '🏂', name: 'snowboarder', tr: 'snowboardcu kar' },
    { emoji: '🏋️', name: 'weightlifting', tr: 'halter spor kas' },
    { emoji: '🤸', name: 'cartwheel', tr: 'jimnastik takla' },
    { emoji: '🤼', name: 'wrestling', tr: 'güreş' },
    { emoji: '🤽', name: 'water_polo', tr: 'su topu' },
    { emoji: '🤾', name: 'handball', tr: 'hentbol' },
    { emoji: '🤺', name: 'fencing', tr: 'eskrim kılıç' },
    { emoji: '🏇', name: 'horse_racing', tr: 'at yarışı jokey' },
    { emoji: '⛷️', name: 'skier', tr: 'kayakçı kar' },
    { emoji: '🏊', name: 'swimming', tr: 'yüzme havuz' },
    { emoji: '🏄', name: 'surfing', tr: 'sörf dalga' },
    { emoji: '🚣', name: 'rowing', tr: 'kürek çekme kayık' },
    { emoji: '🧗', name: 'climbing', tr: 'tırmanma dağ' },
    { emoji: '🚴', name: 'cycling', tr: 'bisiklet' },
    { emoji: '🚵', name: 'mountain_biking', tr: 'dağ bisikleti' },
    { emoji: '🤹', name: 'juggling', tr: 'hokkabazlık' },
    { emoji: '🎪', name: 'circus', tr: 'sirk çadır' },
    { emoji: '🎭', name: 'performing_arts', tr: 'sahne sanatları tiyatro' },
    { emoji: '🎨', name: 'art', tr: 'sanat palet boya' },
    { emoji: '🎬', name: 'clapper', tr: 'klaket film sinema' },
    { emoji: '🎤', name: 'microphone', tr: 'mikrofon şarkı söyleme' },
    { emoji: '🎧', name: 'headphones', tr: 'kulaklık müzik' },
    { emoji: '🎼', name: 'musical_score', tr: 'nota müzik' },
    { emoji: '🎹', name: 'piano', tr: 'piyano klavye müzik' },
    { emoji: '🥁', name: 'drum', tr: 'davul bateri' },
    { emoji: '🎷', name: 'saxophone', tr: 'saksafon caz' },
    { emoji: '🎺', name: 'trumpet', tr: 'trompet' },
    { emoji: '🎸', name: 'guitar', tr: 'gitar müzik rock' },
    { emoji: '🪕', name: 'banjo', tr: 'banjo' },
    { emoji: '🎻', name: 'violin', tr: 'keman klasik müzik' },
    { emoji: '🎲', name: 'dice', tr: 'zar oyun kumar' },
    { emoji: '♟️', name: 'chess', tr: 'satranç piyon' },
    { emoji: '🎯', name: 'dart', tr: 'dart hedef' },
    { emoji: '🎳', name: 'bowling', tr: 'bowling' },
    { emoji: '🎮', name: 'video_game', tr: 'video oyunu konsol' },
    { emoji: '🎰', name: 'slot_machine', tr: 'slot makina kumar' },
    { emoji: '🧩', name: 'puzzle', tr: 'yapboz bulmaca' },
  ],

  'Seyahat ve Yerler': [
    { emoji: '🚗', name: 'car', tr: 'araba oto kırmızı' },
    { emoji: '🚕', name: 'taxi', tr: 'taksi sarı' },
    { emoji: '🚙', name: 'blue_car', tr: 'mavi araba' },
    { emoji: '🚌', name: 'bus', tr: 'otobüs toplu taşıma' },
    { emoji: '🚎', name: 'trolleybus', tr: 'troleybüs' },
    { emoji: '🏎️', name: 'race_car', tr: 'yarış arabası hızlı' },
    { emoji: '🚓', name: 'police_car', tr: 'polis arabası' },
    { emoji: '🚑', name: 'ambulance', tr: 'ambulans' },
    { emoji: '🚒', name: 'fire_engine', tr: 'itfaiye' },
    { emoji: '🚐', name: 'minibus', tr: 'minibüs dolmuş' },
    { emoji: '🚚', name: 'truck', tr: 'kamyon' },
    { emoji: '🚛', name: 'articulated_lorry', tr: 'tır' },
    { emoji: '🚜', name: 'tractor', tr: 'traktör tarım' },
    { emoji: '🏍️', name: 'motorcycle', tr: 'motosiklet motor' },
    { emoji: '🛵', name: 'scooter', tr: 'scooter vespa' },
    { emoji: '🚲', name: 'bike', tr: 'bisiklet' },
    { emoji: '🛴', name: 'kick_scooter', tr: 'scooter kaykay' },
    { emoji: '🚏', name: 'bus_stop', tr: 'otobüs durağı' },
    { emoji: '🛣️', name: 'motorway', tr: 'otoyol yol' },
    { emoji: '🛤️', name: 'railway', tr: 'demiryolu ray' },
    { emoji: '⛽', name: 'fuel', tr: 'benzin istasyon yakıt' },
    { emoji: '🚨', name: 'police_light', tr: 'polis ışığı alarm' },
    { emoji: '🚥', name: 'traffic_light', tr: 'trafik ışığı' },
    { emoji: '🚦', name: 'vertical_traffic_light', tr: 'dikey trafik ışığı' },
    { emoji: '🚧', name: 'construction', tr: 'inşaat yapım' },
    { emoji: '⚓', name: 'anchor', tr: 'çapa gemi' },
    { emoji: '⛵', name: 'sailboat', tr: 'yelkenli tekne' },
    { emoji: '🚤', name: 'speedboat', tr: 'sürat teknesi hızlı' },
    { emoji: '🛥️', name: 'motor_boat', tr: 'motorlu tekne' },
    { emoji: '🛳️', name: 'cruise_ship', tr: 'kruvaziyer gemi' },
    { emoji: '⛴️', name: 'ferry', tr: 'feribot vapur' },
    { emoji: '🚢', name: 'ship', tr: 'gemi' },
    { emoji: '✈️', name: 'airplane', tr: 'uçak' },
    { emoji: '🛩️', name: 'small_plane', tr: 'küçük uçak' },
    { emoji: '🛫', name: 'airplane_departure', tr: 'uçak kalkış' },
    { emoji: '🛬', name: 'airplane_arrival', tr: 'uçak iniş varış' },
    { emoji: '🪂', name: 'parachute', tr: 'paraşüt' },
    { emoji: '💺', name: 'seat', tr: 'koltuk oturma' },
    { emoji: '🚁', name: 'helicopter', tr: 'helikopter' },
    { emoji: '🚟', name: 'monorail', tr: 'monorail tren' },
    { emoji: '🚠', name: 'mountain_cableway', tr: 'teleferik dağ' },
    { emoji: '🚡', name: 'aerial_tramway', tr: 'hava tramvay' },
    { emoji: '🛰️', name: 'satellite', tr: 'uydu uzay' },
    { emoji: '🚀', name: 'rocket', tr: 'roket uzay' },
    { emoji: '🛸', name: 'flying_saucer', tr: 'ufo uzay gemisi' },
    { emoji: '🚂', name: 'locomotive', tr: 'buharlı tren' },
    { emoji: '🚃', name: 'railway_car', tr: 'vagon tren' },
    { emoji: '🚄', name: 'bullet_train', tr: 'hızlı tren japon' },
    { emoji: '🚅', name: 'bullet_train_front', tr: 'hızlı tren ön' },
    { emoji: '🚆', name: 'train', tr: 'tren' },
    { emoji: '🚇', name: 'metro', tr: 'metro yeraltı' },
    { emoji: '🚈', name: 'light_rail', tr: 'hafif raylı' },
    { emoji: '🚉', name: 'station', tr: 'istasyon' },
    { emoji: '🚊', name: 'tram', tr: 'tramvay' },
    { emoji: '🚝', name: 'monorail', tr: 'monorail' },
    { emoji: '🚞', name: 'mountain_railway', tr: 'dağ treni' },
    { emoji: '🚋', name: 'tram_car', tr: 'tramvay vagonu' },
    { emoji: '🚌', name: 'bus', tr: 'otobüs' },
    { emoji: '🚍', name: 'oncoming_bus', tr: 'karşıdan gelen otobüs' },
    { emoji: '🚎', name: 'trolleybus', tr: 'troleybüs' },
    { emoji: '🚐', name: 'minibus', tr: 'minibüs' },
    { emoji: '🚑', name: 'ambulance', tr: 'ambulans acil' },
    { emoji: '🚒', name: 'fire_engine', tr: 'itfaiye yangın' },
    { emoji: '🚓', name: 'police_car', tr: 'polis arabası' },
    { emoji: '🚔', name: 'oncoming_police', tr: 'karşıdan polis' },
    { emoji: '🚕', name: 'taxi', tr: 'taksi' },
    { emoji: '🚖', name: 'oncoming_taxi', tr: 'karşıdan taksi' },
    { emoji: '🚗', name: 'car', tr: 'araba oto' },
    { emoji: '🚘', name: 'oncoming_car', tr: 'karşıdan araba' },
  ],

  'Objeler': [
    { emoji: '⌚', name: 'watch', tr: 'saat kol saati' },
    { emoji: '📱', name: 'phone', tr: 'telefon cep telefon mobil' },
    { emoji: '📲', name: 'calling', tr: 'arama telefon' },
    { emoji: '💻', name: 'computer', tr: 'bilgisayar laptop' },
    { emoji: '⌨️', name: 'keyboard', tr: 'klavye tuş' },
    { emoji: '🖥️', name: 'desktop', tr: 'masaüstü bilgisayar' },
    { emoji: '🖨️', name: 'printer', tr: 'yazıcı' },
    { emoji: '🖱️', name: 'mouse', tr: 'fare bilgisayar' },
    { emoji: '🖲️', name: 'trackball', tr: 'trackball fare' },
    { emoji: '🕹️', name: 'joystick', tr: 'joystick oyun' },
    { emoji: '💽', name: 'minidisc', tr: 'minidisk' },
    { emoji: '💾', name: 'floppy_disk', tr: 'disket kaydet' },
    { emoji: '💿', name: 'cd', tr: 'cd disk' },
    { emoji: '📀', name: 'dvd', tr: 'dvd disk' },
    { emoji: '📼', name: 'vhs', tr: 'vhs kaset video' },
    { emoji: '📷', name: 'camera', tr: 'kamera fotoğraf' },
    { emoji: '📸', name: 'camera_flash', tr: 'flaşlı kamera' },
    { emoji: '📹', name: 'video_camera', tr: 'video kamera' },
    { emoji: '🎥', name: 'movie_camera', tr: 'film kamerası sinema' },
    { emoji: '📽️', name: 'projector', tr: 'projektör film' },
    { emoji: '🎞️', name: 'film_frames', tr: 'film karesi' },
    { emoji: '📞', name: 'telephone', tr: 'telefon ahize klasik' },
    { emoji: '☎️', name: 'phone_classic', tr: 'klasik telefon' },
    { emoji: '📟', name: 'pager', tr: 'çağrı cihazı' },
    { emoji: '📠', name: 'fax', tr: 'faks' },
    { emoji: '📺', name: 'tv', tr: 'televizyon' },
    { emoji: '📻', name: 'radio', tr: 'radyo' },
    { emoji: '🎙️', name: 'microphone', tr: 'mikrofon stüdyo' },
    { emoji: '🎚️', name: 'level_slider', tr: 'seviye kaydırıcı ses' },
    { emoji: '🎛️', name: 'control_knobs', tr: 'kontrol düğmeleri' },
    { emoji: '🧭', name: 'compass', tr: 'pusula yön' },
    { emoji: '⏱️', name: 'stopwatch', tr: 'kronometre' },
    { emoji: '⏲️', name: 'timer', tr: 'zamanlayıcı' },
    { emoji: '⏰', name: 'alarm', tr: 'çalar saat alarm' },
    { emoji: '🕰️', name: 'clock', tr: 'saat duvar saati' },
    { emoji: '⌛', name: 'hourglass', tr: 'kum saati bitti' },
    { emoji: '⏳', name: 'hourglass_flowing', tr: 'akan kum saati' },
    { emoji: '📡', name: 'satellite', tr: 'uydu anten' },
    { emoji: '🔋', name: 'battery', tr: 'pil batarya şarj' },
    { emoji: '🔌', name: 'plug', tr: 'elektrik fişi priz' },
    { emoji: '💡', name: 'bulb', tr: 'ampul lamba fikir' },
    { emoji: '🔦', name: 'flashlight', tr: 'el feneri' },
    { emoji: '🕯️', name: 'candle', tr: 'mum' },
    { emoji: '🧯', name: 'fire_extinguisher', tr: 'yangın söndürücü' },
    { emoji: '🛢️', name: 'oil', tr: 'yağ varil petrol' },
    { emoji: '💸', name: 'money_wings', tr: 'uçan para kayıp' },
    { emoji: '💵', name: 'dollar', tr: 'dolar para amerikan' },
    { emoji: '💴', name: 'yen', tr: 'yen para japon' },
    { emoji: '💶', name: 'euro', tr: 'euro para avrupa' },
    { emoji: '💷', name: 'pound', tr: 'sterlin para ingiliz' },
    { emoji: '💰', name: 'moneybag', tr: 'para çuvalı zenginlik dolar' },
    { emoji: '💳', name: 'credit_card', tr: 'kredi kartı banka kartı' },
    { emoji: '💎', name: 'gem', tr: 'mücevher elmas pırlanta' },
    { emoji: '⚖️', name: 'scales', tr: 'terazi adalet denge' },
    { emoji: '🧰', name: 'toolbox', tr: 'alet kutusu tamir' },
    { emoji: '🔧', name: 'wrench', tr: 'İngiliz anahtarı tamir' },
    { emoji: '🔨', name: 'hammer', tr: 'çekiç' },
    { emoji: '⚒️', name: 'hammer_pick', tr: 'çekiç kazma' },
    { emoji: '🛠️', name: 'tools', tr: 'aletler tamir' },
    { emoji: '⛏️', name: 'pick', tr: 'kazma madencilik' },
    { emoji: '🔩', name: 'nut_bolt', tr: 'somun cıvata' },
    { emoji: '⚙️', name: 'gear', tr: 'dişli ayar mekanik' },
    { emoji: '🧱', name: 'brick', tr: 'tuğla duvar' },
    { emoji: '⛓️', name: 'chains', tr: 'zincir' },
    { emoji: '🧲', name: 'magnet', tr: 'mıknatıs' },
    { emoji: '🔫', name: 'gun', tr: 'silah tabanca' },
    { emoji: '💣', name: 'bomb', tr: 'bomba patlama' },
    { emoji: '🧨', name: 'firecracker', tr: 'dinamit patlayıcı' },
    { emoji: '🔪', name: 'knife', tr: 'bıçak kesme' },
    { emoji: '🗡️', name: 'dagger', tr: 'hançer kılıç' },
    { emoji: '⚔️', name: 'crossed_swords', tr: 'çapraz kılıç savaş' },
    { emoji: '🛡️', name: 'shield', tr: 'kalkan koruma' },
    { emoji: '🚬', name: 'smoking', tr: 'sigara içme' },
    { emoji: '⚰️', name: 'coffin', tr: 'tabut ölüm' },
    { emoji: '⚱️', name: 'urn', tr: 'küllük vazo' },
    { emoji: '🏺', name: 'amphora', tr: 'antik testi vazo' },
    { emoji: '🔮', name: 'crystal_ball', tr: 'kristal küre falcı gelecek' },
    { emoji: '📿', name: 'prayer_beads', tr: 'tesbih tespih dua' },
    { emoji: '🧿', name: 'nazar', tr: 'nazar boncuğu göz' },
    { emoji: '💈', name: 'barber', tr: 'berber kuaför' },
    { emoji: '⚗️', name: 'alembic', tr: 'imbik kimya' },
    { emoji: '🔭', name: 'telescope', tr: 'teleskop yıldız uzay' },
    { emoji: '🔬', name: 'microscope', tr: 'mikroskop bilim' },
    { emoji: '🕳️', name: 'hole', tr: 'delik' },
    { emoji: '💊', name: 'pill', tr: 'hap ilaç' },
    { emoji: '💉', name: 'syringe', tr: 'şırınga enjektör aşı' },
    { emoji: '🌡️', name: 'thermometer', tr: 'termometre ateş' },
    { emoji: '🚰', name: 'water', tr: 'içme suyu musluk' },
    { emoji: '🚽', name: 'toilet', tr: 'tuvalet wc' },
    { emoji: '🚿', name: 'shower', tr: 'duş banyo' },
    { emoji: '🛁', name: 'bathtub', tr: 'küvet banyo' },
    { emoji: '🛀', name: 'bath', tr: 'banyo yapma' },
    { emoji: '🧴', name: 'lotion', tr: 'losyon şişe kremş' },
    { emoji: '🧷', name: 'safety_pin', tr: 'çengelli iğne' },
    { emoji: '🧹', name: 'broom', tr: 'süpürge temizlik' },
    { emoji: '🧺', name: 'basket', tr: 'sepet' },
    { emoji: '🧻', name: 'toilet_paper', tr: 'tuvalet kağıdı' },
    { emoji: '🧼', name: 'soap', tr: 'sabun' },
    { emoji: '🧽', name: 'sponge', tr: 'sünger' },
    { emoji: '🧯', name: 'fire_extinguisher', tr: 'yangın söndürücü' },
    { emoji: '🛒', name: 'shopping_cart', tr: 'alışveriş sepeti market' },
  ],

  'Semboller': [
    { emoji: '❤️', name: 'heart', tr: 'kalp aşk sevgi kırmızı' },
    { emoji: '🧡', name: 'orange_heart', tr: 'turuncu kalp' },
    { emoji: '💛', name: 'yellow_heart', tr: 'sarı kalp' },
    { emoji: '💚', name: 'green_heart', tr: 'yeşil kalp' },
    { emoji: '💙', name: 'blue_heart', tr: 'mavi kalp' },
    { emoji: '💜', name: 'purple_heart', tr: 'mor kalp' },
    { emoji: '🖤', name: 'black_heart', tr: 'siyah kalp' },
    { emoji: '🤍', name: 'white_heart', tr: 'beyaz kalp' },
    { emoji: '🤎', name: 'brown_heart', tr: 'kahverengi kalp' },
    { emoji: '💔', name: 'broken_heart', tr: 'kırık kalp üzgün' },
    { emoji: '❣️', name: 'heart_exclamation', tr: 'kalp ünlem' },
    { emoji: '💕', name: 'two_hearts', tr: 'iki kalp' },
    { emoji: '💞', name: 'revolving_hearts', tr: 'dönen kalpler' },
    { emoji: '💓', name: 'heartbeat', tr: 'kalp atışı nabız' },
    { emoji: '💗', name: 'growing_heart', tr: 'büyüyen kalp' },
    { emoji: '💖', name: 'sparkling_heart', tr: 'parlayan kalp' },
    { emoji: '💘', name: 'cupid', tr: 'aşk oku' },
    { emoji: '💝', name: 'gift_heart', tr: 'hediye kalp' },
    { emoji: '💟', name: 'heart_decoration', tr: 'kalp dekorasyon' },
    { emoji: '☮️', name: 'peace', tr: 'barış huzur' },
    { emoji: '✝️', name: 'cross', tr: 'haç hristiyanlık' },
    { emoji: '☪️', name: 'star_crescent', tr: 'yıldız hilal islam' },
    { emoji: '🕉️', name: 'om', tr: 'om hindu' },
    { emoji: '☸️', name: 'wheel_dharma', tr: 'dharma çarkı budizm' },
    { emoji: '✡️', name: 'star_david', tr: 'davut yıldızı yahudilik' },
    { emoji: '🔯', name: 'six_pointed_star', tr: 'altı köşeli yıldız' },
    { emoji: '🕎', name: 'menorah', tr: 'menora yahudilik' },
    { emoji: '☯️', name: 'yin_yang', tr: 'yin yang denge' },
    { emoji: '☦️', name: 'orthodox_cross', tr: 'ortodoks haç' },
    { emoji: '🛐', name: 'worship', tr: 'ibadet yeri dua' },
    { emoji: '⛎', name: 'ophiuchus', tr: 'yılan taşıyıcı burç' },
    { emoji: '♈', name: 'aries', tr: 'koç burcu' },
    { emoji: '♉', name: 'taurus', tr: 'boğa burcu' },
    { emoji: '♊', name: 'gemini', tr: 'ikizler burcu' },
    { emoji: '♋', name: 'cancer', tr: 'yengeç burcu' },
    { emoji: '♌', name: 'leo', tr: 'aslan burcu' },
    { emoji: '♍', name: 'virgo', tr: 'başak burcu' },
    { emoji: '♎', name: 'libra', tr: 'terazi burcu' },
    { emoji: '♏', name: 'scorpio', tr: 'akrep burcu' },
    { emoji: '♐', name: 'sagittarius', tr: 'yay burcu' },
    { emoji: '♑', name: 'capricorn', tr: 'oğlak burcu' },
    { emoji: '♒', name: 'aquarius', tr: 'kova burcu' },
    { emoji: '♓', name: 'pisces', tr: 'balık burcu' },
    { emoji: '🆔', name: 'id', tr: 'kimlik id' },
    { emoji: '⚛️', name: 'atom', tr: 'atom bilim' },
    { emoji: '🉑', name: 'accept', tr: 'kabul japon' },
    { emoji: '☢️', name: 'radioactive', tr: 'radyoaktif tehlike' },
    { emoji: '☣️', name: 'biohazard', tr: 'biyolojik tehlike' },
    { emoji: '📴', name: 'mobile_off', tr: 'telefon kapalı' },
    { emoji: '📳', name: 'vibration', tr: 'titreşim' },
    { emoji: '🈶', name: 'u6709', tr: 'var japon' },
    { emoji: '🈚', name: 'u7121', tr: 'yok japon' },
    { emoji: '🈸', name: 'u7533', tr: 'başvuru japon' },
    { emoji: '🈺', name: 'u55b6', tr: 'açık işletme japon' },
    { emoji: '🈷️', name: 'u6708', tr: 'ay japon' },
    { emoji: '✴️', name: 'eight_pointed_star', tr: 'sekiz köşeli yıldız' },
    { emoji: '🆚', name: 'vs', tr: 'karşı versus' },
    { emoji: '💮', name: 'white_flower', tr: 'beyaz çiçek japon' },
    { emoji: '🉐', name: 'ideograph_advantage', tr: 'avantaj japon' },
    { emoji: '㊙️', name: 'secret', tr: 'gizli japon' },
    { emoji: '㊗️', name: 'congratulations', tr: 'tebrikler japon' },
    { emoji: '🈴', name: 'u5408', tr: 'geçti japon' },
    { emoji: '🈵', name: 'u6e80', tr: 'dolu japon' },
    { emoji: '🈹', name: 'u5272', tr: 'indirim japon' },
    { emoji: '🈲', name: 'u7981', tr: 'yasak japon' },
    { emoji: '🅰️', name: 'a_blood', tr: 'a kan grubu' },
    { emoji: '🅱️', name: 'b_blood', tr: 'b kan grubu' },
    { emoji: '🆎', name: 'ab_blood', tr: 'ab kan grubu' },
    { emoji: '🆑', name: 'cl', tr: 'cl temizle' },
    { emoji: '🅾️', name: 'o_blood', tr: 'o kan grubu' },
    { emoji: '🆘', name: 'sos', tr: 'sos acil yardım' },
    { emoji: '❌', name: 'x', tr: 'çarpı hata yanlış' },
    { emoji: '⭕', name: 'o', tr: 'o işareti doğru' },
    { emoji: '🛑', name: 'stop_sign', tr: 'dur işareti' },
    { emoji: '⛔', name: 'no_entry', tr: 'giriş yok yasak' },
    { emoji: '📛', name: 'name_badge', tr: 'isim rozeti' },
    { emoji: '🚫', name: 'prohibited', tr: 'yasak' },
    { emoji: '💯', name: '100', tr: 'yüz tam puan mükemmel' },
    { emoji: '💢', name: 'anger', tr: 'öfke sinir' },
    { emoji: '♨️', name: 'hotsprings', tr: 'sıcak su kaplıca' },
    { emoji: '🚷', name: 'no_pedestrians', tr: 'yaya yasak' },
    { emoji: '🚯', name: 'no_littering', tr: 'çöp atmak yasak' },
    { emoji: '🚳', name: 'no_bicycles', tr: 'bisiklet yasak' },
    { emoji: '🚱', name: 'non_potable_water', tr: 'içilmez su' },
    { emoji: '🔞', name: 'underage', tr: '18 yaş altı yasak' },
    { emoji: '📵', name: 'no_mobile', tr: 'telefon yasak' },
    { emoji: '🚭', name: 'no_smoking', tr: 'sigara yasak' },
    { emoji: '❗', name: 'exclamation', tr: 'ünlem dikkat' },
    { emoji: '❕', name: 'grey_exclamation', tr: 'gri ünlem' },
    { emoji: '❓', name: 'question', tr: 'soru işareti' },
    { emoji: '❔', name: 'grey_question', tr: 'gri soru işareti' },
    { emoji: '‼️', name: 'bangbang', tr: 'çift ünlem' },
    { emoji: '⁉️', name: 'interrobang', tr: 'soru ünlem' },
    { emoji: '🔅', name: 'low_brightness', tr: 'düşük parlaklık' },
    { emoji: '🔆', name: 'high_brightness', tr: 'yüksek parlaklık' },
    { emoji: '〽️', name: 'part_alternation', tr: 'parça alternatif' },
    { emoji: '⚠️', name: 'warning', tr: 'uyarı dikkat tehlike' },
    { emoji: '🚸', name: 'children_crossing', tr: 'çocuk geçidi' },
    { emoji: '🔱', name: 'trident', tr: 'çatal mızrak poseidon' },
    { emoji: '⚜️', name: 'fleur_de_lis', tr: 'zambak fransız' },
    { emoji: '🔰', name: 'beginner', tr: 'başlangıç yeni japon' },
    { emoji: '♻️', name: 'recycle', tr: 'geri dönüşüm' },
    { emoji: '✅', name: 'check_mark', tr: 'onay işareti doğru' },
    { emoji: '🈯', name: 'u6307', tr: 'işaret japon' },
    { emoji: '💹', name: 'chart', tr: 'grafik yükseliş' },
    { emoji: '❇️', name: 'sparkle', tr: 'ışıltı parlama' },
    { emoji: '✳️', name: 'eight_spoked_asterisk', tr: 'yıldız işareti' },
    { emoji: '❎', name: 'negative_squared_cross', tr: 'kırmızı çarpı' },
    { emoji: '🌐', name: 'globe_meridians', tr: 'dünya internet' },
    { emoji: '💠', name: 'diamond_shape', tr: 'elmas şekli' },
    { emoji: 'Ⓜ️', name: 'metro', tr: 'metro m' },
    { emoji: '🌀', name: 'cyclone', tr: 'siklon döngü' },
    { emoji: '💤', name: 'zzz', tr: 'uyku horultu' },
    { emoji: '🏧', name: 'atm', tr: 'atm bankamatik' },
    { emoji: '🚾', name: 'wc', tr: 'wc tuvalet' },
    { emoji: '♿', name: 'wheelchair', tr: 'engelli erişim' },
    { emoji: '🅿️', name: 'parking', tr: 'park yeri' },
    { emoji: '🈳', name: 'u7a7a', tr: 'boş japon' },
    { emoji: '🈂️', name: 'sa', tr: 'servis japon' },
    { emoji: '🛂', name: 'passport_control', tr: 'pasaport kontrolü' },
    { emoji: '🛃', name: 'customs', tr: 'gümrük' },
    { emoji: '🛄', name: 'baggage_claim', tr: 'bagaj teslim' },
    { emoji: '🛅', name: 'left_luggage', tr: 'emanet' },
    { emoji: '🚹', name: 'mens', tr: 'erkek tuvalet' },
    { emoji: '🚺', name: 'womens', tr: 'kadın tuvalet' },
    { emoji: '🚼', name: 'baby_symbol', tr: 'bebek bakım' },
    { emoji: '🚻', name: 'restroom', tr: 'tuvalet' },
    { emoji: '🚮', name: 'litter_bin', tr: 'çöp kutusu' },
    { emoji: '🎦', name: 'cinema', tr: 'sinema' },
    { emoji: '📶', name: 'signal_strength', tr: 'sinyal gücü' },
    { emoji: '🈁', name: 'koko', tr: 'burada japon' },
    { emoji: '🔣', name: 'symbols', tr: 'semboller' },
    { emoji: 'ℹ️', name: 'information', tr: 'bilgi danışma' },
    { emoji: '🔤', name: 'abc', tr: 'alfabе küçük harf' },
    { emoji: '🔡', name: 'abcd', tr: 'küçük harf' },
    { emoji: '🔠', name: 'capital_abcd', tr: 'büyük harf' },
    { emoji: '🔢', name: '1234', tr: 'sayılar rakam' },
    { emoji: '🔣', name: 'symbols', tr: 'semboller işaret' },
    { emoji: '🔤', name: 'abc', tr: 'abc harfler' },
    { emoji: '#️⃣', name: 'hash', tr: 'hashtag diyez numara' },
    { emoji: '*️⃣', name: 'asterisk', tr: 'yıldız işareti' },
    { emoji: '0️⃣', name: 'zero', tr: 'sıfır 0' },
    { emoji: '1️⃣', name: 'one', tr: 'bir 1' },
    { emoji: '2️⃣', name: 'two', tr: 'iki 2' },
    { emoji: '3️⃣', name: 'three', tr: 'üç 3' },
    { emoji: '4️⃣', name: 'four', tr: 'dört 4' },
    { emoji: '5️⃣', name: 'five', tr: 'beş 5' },
    { emoji: '6️⃣', name: 'six', tr: 'altı 6' },
    { emoji: '7️⃣', name: 'seven', tr: 'yedi 7' },
    { emoji: '8️⃣', name: 'eight', tr: 'sekiz 8' },
    { emoji: '9️⃣', name: 'nine', tr: 'dokuz 9' },
    { emoji: '🔟', name: 'ten', tr: 'on 10' },
    { emoji: '🔼', name: 'arrow_up_small', tr: 'küçük yukarı ok' },
    { emoji: '🔽', name: 'arrow_down_small', tr: 'küçük aşağı ok' },
    { emoji: '⏸️', name: 'pause', tr: 'duraklat' },
    { emoji: '⏯️', name: 'play_pause', tr: 'oynat duraklat' },
    { emoji: '⏹️', name: 'stop', tr: 'dur durdur' },
    { emoji: '⏺️', name: 'record', tr: 'kayıt' },
    { emoji: '⏭️', name: 'next_track', tr: 'sonraki' },
    { emoji: '⏮️', name: 'previous_track', tr: 'önceki' },
    { emoji: '⏩', name: 'fast_forward', tr: 'hızlı ileri' },
    { emoji: '⏪', name: 'rewind', tr: 'geri sarma' },
    { emoji: '⏫', name: 'arrow_double_up', tr: 'çift yukarı ok' },
    { emoji: '⏬', name: 'arrow_double_down', tr: 'çift aşağı ok' },
    { emoji: '◀️', name: 'arrow_backward', tr: 'geri ok' },
    { emoji: '▶️', name: 'arrow_forward', tr: 'ileri ok oynat' },
    { emoji: '🔀', name: 'shuffle', tr: 'karıştır shuffle' },
    { emoji: '🔁', name: 'repeat', tr: 'tekrar döngü' },
    { emoji: '🔂', name: 'repeat_one', tr: 'bir tekrar' },
    { emoji: '🔄', name: 'arrows_counterclockwise', tr: 'yenile geri döndür' },
    { emoji: '🔃', name: 'arrows_clockwise', tr: 'döndür ileri' },
    { emoji: '🎵', name: 'musical_note', tr: 'müzik notası' },
    { emoji: '🎶', name: 'notes', tr: 'müzik notaları' },
    { emoji: '➕', name: 'plus', tr: 'artı toplama' },
    { emoji: '➖', name: 'minus', tr: 'eksi çıkarma' },
    { emoji: '➗', name: 'divide', tr: 'bölme' },
    { emoji: '✖️', name: 'multiply', tr: 'çarpma' },
    { emoji: '♾️', name: 'infinity', tr: 'sonsuzluk' },
    { emoji: '💲', name: 'dollar_sign', tr: 'dolar işareti' },
    { emoji: '💱', name: 'currency_exchange', tr: 'döviz' },
    { emoji: '™️', name: 'trademark', tr: 'ticari marka' },
    { emoji: '©️', name: 'copyright', tr: 'telif hakkı' },
    { emoji: '®️', name: 'registered', tr: 'kayıtlı marka' },
    { emoji: '〰️', name: 'wavy_dash', tr: 'dalgalı çizgi' },
    { emoji: '➰', name: 'curly_loop', tr: 'kıvrımlı döngü' },
    { emoji: '➿', name: 'double_curly_loop', tr: 'çift kıvrım' },
    { emoji: '🔚', name: 'end', tr: 'son bitiş' },
    { emoji: '🔙', name: 'back', tr: 'geri' },
    { emoji: '🔛', name: 'on', tr: 'açık aktif' },
    { emoji: '🔝', name: 'top', tr: 'üst tepe yukarı' },
    { emoji: '🔜', name: 'soon', tr: 'yakında' },
    { emoji: '✔️', name: 'check', tr: 'onay tik doğru' },
    { emoji: '☑️', name: 'check_box', tr: 'onay kutusu' },
    { emoji: '🔘', name: 'radio_button', tr: 'radyo düğmesi' },
    { emoji: '🔴', name: 'red_circle', tr: 'kırmızı daire' },
    { emoji: '🟠', name: 'orange_circle', tr: 'turuncu daire' },
    { emoji: '🟡', name: 'yellow_circle', tr: 'sarı daire' },
    { emoji: '🟢', name: 'green_circle', tr: 'yeşil daire' },
    { emoji: '🔵', name: 'blue_circle', tr: 'mavi daire' },
    { emoji: '🟣', name: 'purple_circle', tr: 'mor daire' },
    { emoji: '🟤', name: 'brown_circle', tr: 'kahverengi daire' },
    { emoji: '⚫', name: 'black_circle', tr: 'siyah daire' },
    { emoji: '⚪', name: 'white_circle', tr: 'beyaz daire' },
    { emoji: '🟥', name: 'red_square', tr: 'kırmızı kare' },
    { emoji: '🟧', name: 'orange_square', tr: 'turuncu kare' },
    { emoji: '🟨', name: 'yellow_square', tr: 'sarı kare' },
    { emoji: '🟩', name: 'green_square', tr: 'yeşil kare' },
    { emoji: '🟦', name: 'blue_square', tr: 'mavi kare' },
    { emoji: '🟪', name: 'purple_square', tr: 'mor kare' },
    { emoji: '🟫', name: 'brown_square', tr: 'kahverengi kare' },
    { emoji: '⬛', name: 'black_large_square', tr: 'siyah kare' },
    { emoji: '⬜', name: 'white_large_square', tr: 'beyaz kare' },
    { emoji: '◼️', name: 'black_medium_square', tr: 'orta siyah kare' },
    { emoji: '◻️', name: 'white_medium_square', tr: 'orta beyaz kare' },
    { emoji: '◾', name: 'black_medium_small_square', tr: 'küçük siyah kare' },
    { emoji: '◽', name: 'white_medium_small_square', tr: 'küçük beyaz kare' },
    { emoji: '▪️', name: 'black_small_square', tr: 'mini siyah kare' },
    { emoji: '▫️', name: 'white_small_square', tr: 'mini beyaz kare' },
    { emoji: '🔶', name: 'large_orange_diamond', tr: 'büyük turuncu elmas' },
    { emoji: '🔷', name: 'large_blue_diamond', tr: 'büyük mavi elmas' },
    { emoji: '🔸', name: 'small_orange_diamond', tr: 'küçük turuncu elmas' },
    { emoji: '🔹', name: 'small_blue_diamond', tr: 'küçük mavi elmas' },
    { emoji: '🔺', name: 'small_red_triangle', tr: 'küçük kırmızı üçgen' },
    { emoji: '🔻', name: 'small_red_triangle_down', tr: 'aşağı kırmızı üçgen' },
    { emoji: '💠', name: 'diamond_dot', tr: 'noktalı elmas' },
    { emoji: '🔘', name: 'radio_button', tr: 'radyo düğmesi seçim' },
    { emoji: '🔳', name: 'white_square_button', tr: 'beyaz kare düğme' },
    { emoji: '🔲', name: 'black_square_button', tr: 'siyah kare düğme' },
  ],

  'Bayraklar': [
    { emoji: '🏁', name: 'checkered_flag', tr: 'damalı bayrak yarış' },
    { emoji: '🚩', name: 'triangular_flag', tr: 'üçgen bayrak kırmızı' },
    { emoji: '🎌', name: 'crossed_flags', tr: 'çapraz bayraklar japon' },
    { emoji: '🏴', name: 'black_flag', tr: 'siyah bayrak korsan' },
    { emoji: '🏳️', name: 'white_flag', tr: 'beyaz bayrak teslim' },
    { emoji: '🏳️‍🌈', name: 'rainbow_flag', tr: 'gökkuşağı bayrak lgbt' },
    { emoji: '🏴‍☠️', name: 'pirate_flag', tr: 'korsan bayrak' },
    { emoji: '🇹🇷', name: 'turkey', tr: 'türkiye bayrak türk' },
    { emoji: '🇺🇸', name: 'us', tr: 'amerika bayrak abd' },
    { emoji: '🇬🇧', name: 'gb', tr: 'ingiltere bayrak ingiliz' },
    { emoji: '🇩🇪', name: 'germany', tr: 'almanya bayrak alman' },
    { emoji: '🇫🇷', name: 'france', tr: 'fransa bayrak fransız' },
    { emoji: '🇮🇹', name: 'italy', tr: 'italya bayrak italyan' },
    { emoji: '🇪🇸', name: 'spain', tr: 'ispanya bayrak ispanyol' },
    { emoji: '🇷🇺', name: 'russia', tr: 'rusya bayrak rus' },
    { emoji: '🇨🇳', name: 'china', tr: 'çin bayrak çinli' },
    { emoji: '🇯🇵', name: 'japan', tr: 'japonya bayrak japon' },
    { emoji: '🇰🇷', name: 'south_korea', tr: 'güney kore bayrak koreli' },
    { emoji: '🇸🇦', name: 'saudi_arabia', tr: 'suudi arabistan bayrak' },
    { emoji: '🇦🇪', name: 'uae', tr: 'birleşik arap emirlikleri bayrak dubai' },
  ],

  'Doğa': [
    { emoji: '☀️', name: 'sun', tr: 'güneş güneşli sıcak' },
    { emoji: '🌞', name: 'sun_face', tr: 'yüzlü güneş' },
    { emoji: '🌝', name: 'full_moon_face', tr: 'yüzlü dolunay' },
    { emoji: '🌛', name: 'first_quarter_moon_face', tr: 'yüzlü çeyrek ay' },
    { emoji: '🌜', name: 'last_quarter_moon_face', tr: 'yüzlü son çeyrek' },
    { emoji: '🌚', name: 'new_moon_face', tr: 'yüzlü yeni ay' },
    { emoji: '🌕', name: 'full_moon', tr: 'dolunay' },
    { emoji: '🌖', name: 'waning_gibbous_moon', tr: 'azalan ay' },
    { emoji: '🌗', name: 'last_quarter_moon', tr: 'son çeyrek ay' },
    { emoji: '🌘', name: 'waning_crescent_moon', tr: 'azalan hilal' },
    { emoji: '🌑', name: 'new_moon', tr: 'yeni ay' },
    { emoji: '🌒', name: 'waxing_crescent_moon', tr: 'büyüyen hilal' },
    { emoji: '🌓', name: 'first_quarter_moon', tr: 'ilk çeyrek ay' },
    { emoji: '🌔', name: 'waxing_gibbous_moon', tr: 'büyüyen ay' },
    { emoji: '🌙', name: 'crescent_moon', tr: 'hilal ay' },
    { emoji: '🌎', name: 'earth_americas', tr: 'dünya amerika kıtası' },
    { emoji: '🌍', name: 'earth_africa', tr: 'dünya afrika kıtası' },
    { emoji: '🌏', name: 'earth_asia', tr: 'dünya asya kıtası' },
    { emoji: '🪐', name: 'saturn', tr: 'satürn gezegen' },
    { emoji: '💫', name: 'dizzy', tr: 'sersem yıldız baş dönmesi' },
    { emoji: '⭐', name: 'star', tr: 'yıldız parlak' },
    { emoji: '🌟', name: 'glowing_star', tr: 'parlayan yıldız' },
    { emoji: '✨', name: 'sparkles', tr: 'parıltılar ışıltı' },
    { emoji: '⚡', name: 'zap', tr: 'şimşek yıldırım elektrik' },
    { emoji: '☄️', name: 'comet', tr: 'kuyruklu yıldız' },
    { emoji: '💥', name: 'boom', tr: 'patlama' },
    { emoji: '🔥', name: 'fire', tr: 'ateş alev yangın sıcak' },
    { emoji: '🌪️', name: 'tornado', tr: 'hortum kasırga' },
    { emoji: '🌈', name: 'rainbow', tr: 'gökkuşağı renkli' },
    { emoji: '☁️', name: 'cloud', tr: 'bulut bulutlu' },
    { emoji: '⛅', name: 'partly_sunny', tr: 'parçalı bulutlu' },
    { emoji: '⛈️', name: 'thunder_cloud_rain', tr: 'fırtına yağmur şimşek' },
    { emoji: '🌤️', name: 'white_sun_small_cloud', tr: 'güneşli az bulutlu' },
    { emoji: '🌥️', name: 'white_sun_cloud', tr: 'güneş bulut' },
    { emoji: '🌦️', name: 'white_sun_rain_cloud', tr: 'yağmurlu güneş' },
    { emoji: '🌧️', name: 'cloud_rain', tr: 'yağmurlu bulut yağmur' },
    { emoji: '🌨️', name: 'cloud_snow', tr: 'karlı bulut kar' },
    { emoji: '🌩️', name: 'cloud_lightning', tr: 'şimşekli bulut' },
    { emoji: '🌬️', name: 'wind_blowing', tr: 'rüzgar esen' },
    { emoji: '💨', name: 'dash', tr: 'hız koşma rüzgar' },
    { emoji: '💧', name: 'droplet', tr: 'damla su' },
    { emoji: '💦', name: 'sweat_drops', tr: 'ter damlaları su' },
    { emoji: '☔', name: 'umbrella', tr: 'şemsiye yağmur' },
    { emoji: '☂️', name: 'umbrella2', tr: 'şemsiye açık' },
    { emoji: '🌊', name: 'ocean', tr: 'okyanus dalga deniz' },
    { emoji: '🌫️', name: 'fog', tr: 'sis sisli' },
    { emoji: '🌀', name: 'cyclone', tr: 'siklon kasırga' },
    { emoji: '🌬️', name: 'wind_face', tr: 'rüzgar yüz' },
    { emoji: '🌁', name: 'foggy', tr: 'sisli hava' },
    { emoji: '🌃', name: 'night_stars', tr: 'gece yıldızlar şehir' },
    { emoji: '🌄', name: 'sunrise_mountains', tr: 'gün doğumu dağlar' },
    { emoji: '🌅', name: 'sunrise', tr: 'gün doğumu' },
    { emoji: '🌆', name: 'cityscape', tr: 'şehir manzarası' },
    { emoji: '🌇', name: 'sunset', tr: 'gün batımı' },
    { emoji: '🌉', name: 'bridge_night', tr: 'köprü gece' },
    { emoji: '♨️', name: 'hotsprings', tr: 'sıcak su kaplıca' },
    { emoji: '🎠', name: 'carousel_horse', tr: 'atlıkarınca at' },
    { emoji: '🎡', name: 'ferris_wheel', tr: 'dönme dolap' },
    { emoji: '🎢', name: 'roller_coaster', tr: 'lunapark hız treni' },
    { emoji: '💈', name: 'barber', tr: 'berber kuaför' },
    { emoji: '🎪', name: 'circus_tent', tr: 'sirk çadır' },
    { emoji: '🚂', name: 'steam_locomotive', tr: 'buharlı tren' },
    { emoji: '🚃', name: 'railway_car', tr: 'tren vagonu' },
    { emoji: '🚄', name: 'high_speed_train', tr: 'hızlı tren' },
    { emoji: '🚅', name: 'bullet_train', tr: 'kurşun tren japon' },
    { emoji: '🚆', name: 'train2', tr: 'tren' },
    { emoji: '🚇', name: 'metro', tr: 'metro yeraltı' },
    { emoji: '🚈', name: 'light_rail', tr: 'hafif raylı sistem' },
    { emoji: '🚉', name: 'station', tr: 'istasyon tren' },
    { emoji: '🚊', name: 'tram', tr: 'tramvay' },
    { emoji: '🚝', name: 'monorail', tr: 'monorail tek ray' },
    { emoji: '🚞', name: 'mountain_railway', tr: 'dağ treni teleferik' },
    { emoji: '🚋', name: 'tram_car', tr: 'tramvay vagonu' },
    { emoji: '🚌', name: 'bus', tr: 'otobüs' },
    { emoji: '🚍', name: 'oncoming_bus', tr: 'karşıdan gelen otobüs' },
    { emoji: '🚎', name: 'trolleybus', tr: 'troleybüs' },
    { emoji: '🚐', name: 'minibus', tr: 'minibüs' },
    { emoji: '🚑', name: 'ambulance', tr: 'ambulans acil' },
    { emoji: '🚒', name: 'fire_engine', tr: 'itfaiye yangın' },
    { emoji: '🚓', name: 'police_car', tr: 'polis arabası' },
    { emoji: '🚔', name: 'oncoming_police_car', tr: 'karşıdan polis' },
    { emoji: '🚕', name: 'taxi', tr: 'taksi' },
    { emoji: '🚖', name: 'oncoming_taxi', tr: 'karşıdan taksi' },
    { emoji: '🚗', name: 'car', tr: 'araba oto' },
    { emoji: '🚘', name: 'oncoming_automobile', tr: 'karşıdan araba' },
    { emoji: '🚙', name: 'blue_car', tr: 'mavi araba suv' },
    { emoji: '🛻', name: 'pickup_truck', tr: 'kamyonet pickup' },
    { emoji: '🚚', name: 'truck', tr: 'kamyon' },
    { emoji: '🚛', name: 'articulated_lorry', tr: 'tır çekici' },
    { emoji: '🚜', name: 'tractor', tr: 'traktör tarım' },
    { emoji: '🏎️', name: 'racing_car', tr: 'yarış arabası formula' },
    { emoji: '🏍️', name: 'motorcycle', tr: 'motosiklet motor' },
    { emoji: '🛵', name: 'motor_scooter', tr: 'motor scooter' },
    { emoji: '🦽', name: 'manual_wheelchair', tr: 'manuel tekerlekli sandalye' },
    { emoji: '🦼', name: 'motorized_wheelchair', tr: 'motorlu tekerlekli sandalye' },
    { emoji: '🛺', name: 'auto_rickshaw', tr: 'rikşa tuk tuk' },
    { emoji: '🚲', name: 'bicycle', tr: 'bisiklet' },
    { emoji: '🛴', name: 'kick_scooter', tr: 'scooter' },
    { emoji: '🛹', name: 'skateboard', tr: 'kaykay' },
    { emoji: '🛼', name: 'roller_skate', tr: 'paten tekerlekli' },
    { emoji: '🚏', name: 'busstop', tr: 'otobüs durağı' },
    { emoji: '🛣️', name: 'motorway', tr: 'otoyol' },
    { emoji: '🛤️', name: 'railway_track', tr: 'demiryolu' },
    { emoji: '🛢️', name: 'oil_drum', tr: 'petrol varili yağ' },
    { emoji: '⛽', name: 'fuelpump', tr: 'benzin pompası yakıt' },
    { emoji: '🚨', name: 'rotating_light', tr: 'döner lamba polis alarm' },
    { emoji: '🚥', name: 'traffic_light', tr: 'trafik ışığı' },
    { emoji: '🚦', name: 'vertical_traffic_light', tr: 'dikey trafik ışığı' },
    { emoji: '🛑', name: 'stop_sign', tr: 'dur işareti' },
    { emoji: '🚧', name: 'construction', tr: 'inşaat yapım yol çalışması' },
    { emoji: '⚓', name: 'anchor', tr: 'çapa gemi' },
    { emoji: '⛵', name: 'sailboat', tr: 'yelkenli tekne' },
    { emoji: '🛶', name: 'canoe', tr: 'kano kayık' },
    { emoji: '🚤', name: 'speedboat', tr: 'sürat teknesi' },
    { emoji: '🛳️', name: 'passenger_ship', tr: 'yolcu gemisi kruvaziyer' },
    { emoji: '⛴️', name: 'ferry', tr: 'feribot vapur' },
    { emoji: '🛥️', name: 'motor_boat', tr: 'motorlu tekne' },
    { emoji: '🚢', name: 'ship', tr: 'gemi' },
    { emoji: '✈️', name: 'airplane', tr: 'uçak' },
    { emoji: '🛩️', name: 'small_airplane', tr: 'küçük uçak' },
    { emoji: '🛫', name: 'airplane_departure', tr: 'uçak kalkış' },
    { emoji: '🛬', name: 'airplane_arrival', tr: 'uçak iniş' },
    { emoji: '🪂', name: 'parachute', tr: 'paraşüt' },
    { emoji: '💺', name: 'seat', tr: 'koltuk uçak' },
    { emoji: '🚁', name: 'helicopter', tr: 'helikopter' },
    { emoji: '🚟', name: 'suspension_railway', tr: 'asma demiryolu' },
    { emoji: '🚠', name: 'mountain_cableway', tr: 'dağ teleferik' },
    { emoji: '🚡', name: 'aerial_tramway', tr: 'hava tramvay teleferik' },
    { emoji: '🛰️', name: 'satellite', tr: 'uydu uzay' },
    { emoji: '🚀', name: 'rocket', tr: 'roket uzay' },
    { emoji: '🛸', name: 'flying_saucer', tr: 'ufo uzay gemisi' },
    { emoji: '🪐', name: 'ringed_planet', tr: 'satürn halkalı gezegen' },
    { emoji: '⭐', name: 'star', tr: 'yıldız' },
    { emoji: '🌠', name: 'shooting_star', tr: 'kayan yıldız dilek' },
    { emoji: '🌌', name: 'milky_way', tr: 'samanyolu galaksi' },
    { emoji: '☁️', name: 'cloud', tr: 'bulut' },
    { emoji: '⛅', name: 'partly_sunny', tr: 'parçalı bulutlu' },
  ],

  'Bitkiler ve Çiçekler': [
    { emoji: '🌲', name: 'evergreen_tree', tr: 'çam ağacı yeşil' },
    { emoji: '🌳', name: 'deciduous_tree', tr: 'yapraklı ağaç' },
    { emoji: '🌴', name: 'palm_tree', tr: 'palmiye ağacı tropikal' },
    { emoji: '🌵', name: 'cactus', tr: 'kaktüs çöl' },
    { emoji: '🌾', name: 'ear_of_rice', tr: 'pirinç başağı buğday' },
    { emoji: '🌿', name: 'herb', tr: 'ot bitki yaprak' },
    { emoji: '☘️', name: 'shamrock', tr: 'yonca üç yaprak' },
    { emoji: '🍀', name: 'four_leaf_clover', tr: 'dört yapraklı yonca şans' },
    { emoji: '🍁', name: 'maple_leaf', tr: 'akçaağaç yaprağı sonbahar kanada' },
    { emoji: '🍂', name: 'fallen_leaf', tr: 'düşmüş yaprak sonbahar' },
    { emoji: '🍃', name: 'leaves', tr: 'yapraklar rüzgar' },
    { emoji: '🌺', name: 'hibiscus', tr: 'hibiskus çiçek tropikal' },
    { emoji: '🌻', name: 'sunflower', tr: 'ayçiçeği sarı' },
    { emoji: '🌹', name: 'rose', tr: 'gül kırmızı romantik' },
    { emoji: '🥀', name: 'wilted_flower', tr: 'solmuş çiçek gül üzgün' },
    { emoji: '🌷', name: 'tulip', tr: 'lale çiçek bahar hollanda' },
    { emoji: '🌼', name: 'blossom', tr: 'çiçek papatya beyaz' },
    { emoji: '🌸', name: 'cherry_blossom', tr: 'kiraz çiçeği pembe japon' },
    { emoji: '💐', name: 'bouquet', tr: 'buket çiçek demeti hediye' },
    { emoji: '🍄', name: 'mushroom', tr: 'mantar kırmızı' },
    { emoji: '🌰', name: 'chestnut', tr: 'kestane' },
    { emoji: '🦀', name: 'crab', tr: 'yengeç deniz' },
    { emoji: '🦞', name: 'lobster', tr: 'ıstakoz deniz' },
    { emoji: '🦐', name: 'shrimp', tr: 'karides deniz' },
    { emoji: '🦑', name: 'squid', tr: 'kalamar deniz' },
    { emoji: '🐚', name: 'shell', tr: 'deniz kabuğu midye' },
  ]
};

// Tüm emojileri düz liste olarak
export const allEmojis = Object.values(emojiCategories).flat();

// Emoji arama fonksiyonu
export const searchEmojis = (searchTerm) => {
  if (!searchTerm || searchTerm.length < 2) return [];
  
  const normalizedSearch = searchTerm.toLowerCase().trim();
  const results = [];
  
  allEmojis.forEach(emojiData => {
    // İngilizce ve Türkçe içeriği birleştir
    const searchableText = `${emojiData.name} ${emojiData.tr}`.toLowerCase();
    
    // Eşleşme varsa ekle
    if (searchableText.includes(normalizedSearch)) {
      results.push(emojiData);
    }
  });
  
  // İlk 50 sonucu döndür (performans için)
  return results.slice(0, 50);
};